import loadable from '@loadable/component';

export const LoadableSomethingWentWrongPage = loadable(
  () => import(/* webpackChunkName: "ErrorPages" */ './SomethingWentWrongPage'),
);
